module.exports = __webpack_public_path__ + "img/3d15f1112674237c6c56edeaadc8607c.png";